import { useEffect, useRef, useState } from 'react';
import Moment from 'moment';
import { NavLink } from 'react-router'
import PilotageApiRepository from '../../../repositories/api/PilotageApiRepository';
import PilotageIdbRepository from '../../../repositories/idb/PilotageIdbRepository';

import Spacer from '../../../components/layout/Spacer';
import { Button } from "@progress/kendo-react-buttons";
import PilotageVoyageDialog from './PilotageVoyageDialog';
import { Card } from '../../../components/layout/card/Card';
import { formatForSave, toDateObject } from '../../../components/helpers/DateTimeHelpers';
import { PilotageToTimeDialog } from './PilotageArrivalTimeDialog';
import { useSuccessNotification, useWarningNotification } from 'components/hooks/useAppStore';

export default function PilotageDetailLocation({ state: pilotage, isReadOnly }) {
    const [arrivalTime, setArrivalTime] = useState(null);
    const [showArrivalTimeDialog, setShowArrivalTimeDialog] = useState(false);
    const [showPreviousVoyages, setShowPreviousVoyages] = useState(false);

    const addSuccessNotification = useSuccessNotification();
    const addWarningNotification = useWarningNotification();

    useEffect(() => {
        const time = toDateObject(formatForSave(Moment(pilotage.pilotageDetail.fromTime)
            .add(pilotage.pilotageDetail.pilotageEstimatedDurationInMinutes, 'm')));
        setArrivalTime(new Date(time));
    }, [pilotage.pilotageDetail.pilotageEstimatedDurationInMinutes, pilotage.pilotageDetail.fromTime])

    return (
        <>
            <Card title={`${pilotage.fromLocation.name}`}>
                <div className="details-time">
                    <div>{Moment(pilotage.pilotageDetail.fromTime).format("DD.MM HH:mm")}</div>
                </div>
                <div className="details-quay">
                    <div>{pilotage.pilotageDetail?.departureQuayInfo}</div>
                    {pilotage.fromLocation.hasQuayManualsInProximity && (
                            <NavLink
                                to={{
                                    pathname: `/quaymanuals/${pilotage.fromLocation.locationId}/proximity`,
                                    search: `title=${pilotage.fromLocation.name}`,
                                }}
                            >
                                Kaibok
                            </NavLink>
                    )}
                </div>
                <Spacer height={15} />
                <div className="details-card-title font-size-xl">{`${pilotage.toLocation.name}`}</div>
                <div className="details-time">
                    {!isReadOnly && navigator.onLine ? (
                        <>
                            <div className="full">{Moment(arrivalTime).format("DD.MM HH:mm")}</div>
                            <div>
                                <Button
                                    onClick={toggleShowArrivalTimeDialog}
                                    className="m-l-10"
                                    fillMode="solid"
                                    themeColor="primary"
                                    size={"small"}
                                >
                                    Endre
                                </Button>
                            </div>
                        </>
                    ) : (
                        <div>{Moment(arrivalTime).format("DD.MM HH:mm")}</div>
                    )}
                </div>
                <div className="details-quay">
                    <div>{pilotage.pilotageDetail?.arrivalQuayInfo}</div>
                    {pilotage.toLocation.hasQuayManualsInProximity && navigator.onLine && (
                            <NavLink
                                to={{
                                    pathname: `/quaymanuals/${pilotage.toLocation.locationId}/proximity`,
                                    search: `title=${pilotage.toLocation.name}`,
                                }}
                            >
                                Kaibok
                            </NavLink>
                    )}
                </div>
                <Spacer />
                {
                    (navigator.onLine) &&
                    <Button themeColor={"primary"} onClick={() => setShowPreviousVoyages(true)}>
                        Vis seilas
                    </Button>
                }
            </Card>

            {showPreviousVoyages && (
                <PilotageVoyageDialog pilotageId={pilotage.pilotageId} onClose={() => setShowPreviousVoyages(false)} />
            )}

            {showArrivalTimeDialog && (
                <PilotageToTimeDialog value={arrivalTime} onClose={toggleShowArrivalTimeDialog} onSave={handleClickSaveButton} />
            )}
        </>
    );

    function toggleShowArrivalTimeDialog() {
        setShowArrivalTimeDialog(!showArrivalTimeDialog);
    }

    async function sendUpdatePilotageDuration(toTime) {

        var response = await PilotageApiRepository
            .updatePilotageDuration(pilotage.pilotageDetail.pilotageDurationId, formatForSave(toTime));
        if (response.ok === true) {
            let newDuration = await response.json();
            await handleUpdatePilotageDuration(newDuration);
            addSuccessNotification(`Estimert oppdragsvarighet ble oppdatert`);
        } else {
            addWarningNotification(`Oppdragsvarigheten kan ikke være etter fra dato`);
        }
    }

    function calculateNewEstiamedTime(estimatedDurationInMinutes) {
        const time = toDateObject(formatForSave(Moment(pilotage.pilotageDetail.fromTime)
            .add(estimatedDurationInMinutes, 'm')));
        setArrivalTime(time);
        return time;
    }

    async function handleUpdatePilotageDuration(estimatedDurationInMinutes) {
        calculateNewEstiamedTime(estimatedDurationInMinutes);
        pilotage.pilotageDetail.pilotageEstimatedDurationInMinutes = estimatedDurationInMinutes;
        await PilotageIdbRepository.setPilotageAsync(pilotage);
    }

    async function handleClickSaveButton(arrivalTime) {
        sendUpdatePilotageDuration(arrivalTime);
        setShowArrivalTimeDialog(false);
    }
}
